import { useCallback } from "react";
import { hapticFeedback, isHapticFeedbackSupported } from "@telegram-apps/sdk";

export function useRampHaptic() {
  const isSupported =
    typeof window !== "undefined" &&
    (typeof isHapticFeedbackSupported === "function"
      ? isHapticFeedbackSupported()
      : typeof hapticFeedback !== "undefined" || "vibrate" in navigator);

  const ramp = useCallback((delay = 30, steps = 4, gradual = false) => {
    const safeSteps = Math.max(1, Math.min(steps));
    const stepDelay = Math.max(delay);

    const styles = ["soft", "light", "medium", "heavy", "rigid"] as const;
    const totalDuration = safeSteps * stepDelay;

    for (let i = 0; i < safeSteps; i += 1) {
      const t = safeSteps === 1 ? 1 : i / (safeSteps - 1);
      const styleIndex = Math.round(t * (styles.length - 1));
      const style = gradual ? styles[styleIndex] : "soft";

      window.setTimeout(() => {
        hapticFeedback.impactOccurred(style);
      }, i * stepDelay);
    }

    return new Promise<void>((resolve) => {
      window.setTimeout(() => resolve(), totalDuration + 10);
    });
  }, []);

  return { ramp, isSupported };
}
